<template>
  <div>
    <div class="list-item" @click="handleTitleClick">
      <div class="overh list-title">{{ data.dishonestdetail }}</div>
      <div class="list-content">
        <div class="overh content-title">{{ data.qyname }}</div>
        <div class="content-time">{{ commonTime }}</div>
      </div>
    </div>
    <!-- 查看失信详情 -->
    <my-dialog v-model="dialogVisible" width="60%" :showclose="true">
      <template slot="head">失信详情</template>
      <div style="max-height: 60vh; overflow-y: auto">
        <el-descriptions
          class="margin-top"
          title=""
          border
          :column="1"
          :label-style="label_style"
        >
          <el-descriptions-item label="企业名称">{{ info.qyname }}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码(或组织机构代码)">{{
            info.qytyxycode
          }}</el-descriptions-item>
          <el-descriptions-item label="企业地址">{{
            info.qyaddress
          }}</el-descriptions-item>
          <el-descriptions-item label="严重违法失信行为的具体情形">{{
            info.dishonestdetail
          }}</el-descriptions-item>
          <el-descriptions-item label="处罚结果">{{
            info.cfresult
          }}</el-descriptions-item>
          <el-descriptions-item label="处罚依据">{{ info.cfbasis }}</el-descriptions-item>
          <el-descriptions-item label="处罚日期">{{ info.cfdate }}</el-descriptions-item>
          <el-descriptions-item label="公布日期">{{ info.pubdate }}</el-descriptions-item>
          <el-descriptions-item label="执法单位">{{ info.zfdw }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </my-dialog>
  </div>
</template>

<script>
import AdsVue from "@components/sys/ads";
import { ToText, toTime } from "../assets/js/news.js";
export default {
  components: {
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      info: "",
      dialogVisible: false,
      label_style: {
        width: "150px",
      },
    };
  },
  computed: {
    commonTime() {
      if (this.data.pubdate) {
        return this.data.pubdate.indexOf("-") > -1
          ? this.data.pubdate.split(" ")[0]
          : toTime(this.data.pubdate, false);
      }
    },
  },
  mounted() {},
  methods: {
    handleTitleClick() {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "失信名单-详情",
      });
      this.$get(
        `${this.$store.state.api.webUrl}/dishonest/detail.json`,
        {
          guid: this.data.guid,
        },
        (data) => {
          this.dialogVisible = true;
          this.info = data;
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.list-item {
  cursor: pointer;
  margin-top: 11px;

  .list-title{
    font-weight: bold;
  }

  .list-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 400;
    font-size: 14px;
    color: #111111;
    line-height: 38px;

    .content-title {
      color: #666666;
    }

    .content-time {
      white-space: nowrap;
      margin-left: 56px;
      color: #666666;
    }
  }
}
</style>
